/*-----------------------------------------------------------------------------/
 / Custom Theme JS
 /-----------------------------------------------------------------------------*/

// Natural Escapes: place the Yotpo Rewards bar directly below the announcement bar
// and above the main header. Yotpo injects the widget asynchronously, so watch
// briefly for it to appear and move it only when necessary.
(() => {
  const moveRewardsBar = () => {
    const rewards = document.querySelector('.yotpo-widget-loyalty-floater-widget');
    const headerContainer = document.querySelector('header-container');

    if (!rewards || !headerContainer || !headerContainer.parentNode) return false;

    if (rewards.nextElementSibling !== headerContainer) {
      headerContainer.parentNode.insertBefore(rewards, headerContainer);
    }

    return true;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', moveRewardsBar, { once: true });
  } else {
    moveRewardsBar();
  }

  const observer = new MutationObserver(() => {
    if (moveRewardsBar()) observer.disconnect();
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });

  window.setTimeout(() => observer.disconnect(), 10000);
})();
